var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:[
    'btn-base',
    _vm.buttonStyle,
    _vm.isSmall ? 'small-btn' : _vm.buttonSize,
    _vm.isDisabled ? 'disable' : '',
    _vm.kclass
  ],attrs:{"type":"button","disabled":_vm.isDisabled},on:{"click":_vm.onClick}},[(!_vm.loading)?_c('div',{staticClass:"btn-text",domProps:{"innerHTML":_vm._s(_vm.text)}}):_c('div',{staticClass:"spinner"},[_c('Spinner')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }